module.exports = __webpack_public_path__ + "static/media/logo.e6bccb81.png";